import * as React from "react";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import autobind from "autobind-decorator";
import { Button, CircularProgress } from "@mui/material";
import { notification } from "antd";
import firebase from "firebase/compat/app";
import { observable } from "mobx";
import "antd/dist/antd.css";

const PlanContainer = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

const PriceInput = styled("input")({
  padding: "6px 14px",
  border: "1px solid lightgray",
  borderRadius: "4px",
  fontSize: "17px",
  outline: "none",
  margin: "10px",
  width: "100px",
  paddingLeft: "30px",
});

const CurrencyIcon = styled("span")({
  position: "absolute",
  top: "19px",
  color: "gray",
  right: "90px",
  fontSize: "1rem",
});

type pricingPlanProps = {
  name: string;
  pricesData: any;
};

type pricingPlanState = {
  newSellingPrice: string;
  newMarkedPrice: string;
  sellingPrice: string;
  markedPrice: string;
  status: string;
};

type priceStatus = "LOADING" | "NORMAL";

export default class pricingPlan extends React.Component<
  pricingPlanProps,
  pricingPlanState
> {
  state: pricingPlanState = {
    newSellingPrice: "",
    newMarkedPrice: "",
    sellingPrice: this.props.pricesData.filter(
      (plan: any) => plan.planType === this.props.name
    )[0].sellingPrice,
    markedPrice: this.props.pricesData.filter(
      (plan: any) => plan.planType === this.props.name
    )[0].markedPrice,
    status: "NORMAL",
  };

  @observable
  _status: priceStatus = "NORMAL";

  @autobind
  handleChange(event: any) {
    this.setState({ ...this.state, [event.target.name]: event.target.value });
  }

  @autobind
  resetHandler() {
    this.setState({
      newSellingPrice: "",
      newMarkedPrice: "",
    });
  }

  @autobind
  async savePrices() {
    this.setState({
      ...this.state,
      status: "LOADING",
    });
    try {
      const { newSellingPrice, newMarkedPrice } = this.state;
      if (newSellingPrice != "" && newMarkedPrice != "") {
        await firebase
          .firestore()
          .collection("prices")
          .doc(`${this.props.name}`)
          .set(
            {
              sellingPrice: newSellingPrice,
              markedPrice: newMarkedPrice,
            },
            {
              merge: true,
            }
          );
        const fetchData = await firebase.firestore().collection("prices").get();
        const pricesArr = fetchData.docs.map((plan) => plan.data());

        this.setState({
          ...this.state,
          sellingPrice: pricesArr.filter(
            (plan) => plan.planType === this.props.name
          )[0].sellingPrice,
          markedPrice: pricesArr.filter(
            (plan) => plan.planType === this.props.name
          )[0].markedPrice,
          newMarkedPrice: "",
          newSellingPrice: "",
          status: "NORMAL",
        });
        notification.success({
          message: "prices updated successfuly",
          placement: "bottomRight",
          duration: 5,
        });
      } else {
        notification.error({
          message: "Please fill out Fields",
          placement: "bottomRight",
          duration: 5,
        });
        this.setState({
          ...this.state,
          status: "NORMAL",
        });
      }
    } catch (err) {
      console.log(err);
    }
  }

  render() {
    return (
      <PlanContainer>
        <Typography variant="h5" style={{ flexGrow: 1 }}>
          {this.props.name}
        </Typography>

        <label
          htmlFor="selling_price"
          style={{ position: "relative", marginLeft: "20px" }}
        >
          Selling Price
          <CurrencyIcon>$</CurrencyIcon>
          <PriceInput
            name="newSellingPrice"
            type="number"
            placeholder={this.state.sellingPrice}
            value={this.state.newSellingPrice}
            onChange={this.handleChange}
          />
        </label>

        <label
          htmlFor="marked_price"
          style={{ position: "relative", marginLeft: "20px" }}
        >
          Marked Price
          <CurrencyIcon>$</CurrencyIcon>
          <PriceInput
            type="number"
            name="newMarkedPrice"
            placeholder={this.state.markedPrice}
            value={this.state.newMarkedPrice}
            onChange={this.handleChange}
          />
        </label>
        <Button
          variant="contained"
          color="inherit"
          style={{ marginLeft: "40px" }}
          onClick={this.resetHandler}
          disabled={this._status == "LOADING"}
        >
          Reset
        </Button>
        <Button
          variant="contained"
          color="secondary"
          style={{ marginLeft: "20px", width: "72px", color: "#fff" }}
          onClick={this.savePrices}
          disabled={this._status == "LOADING"}
        >
          {this.state.status === "LOADING" ? (
            <CircularProgress
              style={{ width: "24px", height: "24px", color: "#fff" }}
            />
          ) : (
            <Typography>save</Typography>
          )}
        </Button>
      </PlanContainer>
    );
  }
}
